(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  class PasswordReassortCountdown {
    constructor(element) {
      this.element = element;
      this.timeZone = element.dataset.timeZone || 'Europe/Paris';
      this.manualDate = element.dataset.manualDate || '';
      this.manualTime = element.dataset.manualTime || '';
      this.dropTime = element.dataset.dropTime || '20:00';
      this.days = element.querySelector('[data-countdown-days]');
      this.hours = element.querySelector('[data-countdown-hours]');
      this.minutes = element.querySelector('[data-countdown-minutes]');
      this.seconds = element.querySelector('[data-countdown-seconds]');
      this.expired = element.parentElement.querySelector('[data-password-reassort-expired]');
      this.target = this.resolveTarget();
      this.interval = null;
      this.start();
    }

    start() {
      if (!this.target.date) {
        this.target = {
          date: this.getNextAutomaticDrop(new Date()),
          mode: 'auto'
        };
      }

      this.tick();
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    tick() {
      const now = new Date();
      let remaining = this.target.date.getTime() - now.getTime();

      if (remaining <= 0 && this.target.mode === 'auto') {
        this.target.date = this.getNextAutomaticDrop(now);
        remaining = this.target.date.getTime() - now.getTime();
      }

      if (remaining <= 0) {
        window.clearInterval(this.interval);
        this.setValues(0, 0, 0, 0);
        this.showExpired();
        return;
      }

      if (this.expired) {
        this.expired.hidden = true;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      this.setValues(days, hours, minutes, seconds);
    }

    resolveTarget() {
      const manualTarget = this.getManualTarget();

      if (manualTarget) {
        return {
          date: manualTarget,
          mode: 'manual'
        };
      }

      return {
        date: this.getNextAutomaticDrop(new Date()),
        mode: 'auto'
      };
    }

    getManualTarget() {
      const dateMatch = this.manualDate.trim().match(/^(\d{2})-(\d{2})-(\d{4})$/);

      if (!dateMatch) {
        return null;
      }

      const day = Number(dateMatch[1]);
      const month = Number(dateMatch[2]);
      const year = Number(dateMatch[3]);
      const time = this.parseTime(this.manualTime) || this.parseTime(this.dropTime) || { hour: 20, minute: 0 };

      if (!this.isValidDateParts(year, month, day)) {
        return null;
      }

      return this.zonedDateTimeToDate(year, month, day, time.hour, time.minute, this.timeZone);
    }

    getNextAutomaticDrop(now) {
      const time = this.parseTime(this.dropTime) || { hour: 20, minute: 0 };
      const parts = this.getZonedParts(now, this.timeZone);
      const currentDay = this.getDayOfWeek(parts.year, parts.month, parts.day);
      const currentMinutes = parts.hour * 60 + parts.minute;
      const dropMinutes = time.hour * 60 + time.minute;
      let targetDay = currentDay <= 3 ? 3 : 6;

      if (currentDay === 3 && currentMinutes >= dropMinutes) {
        targetDay = 6;
      }

      if (currentDay === 6 && currentMinutes >= dropMinutes) {
        targetDay = 3;
      }

      let daysUntil = targetDay - currentDay;

      if (daysUntil < 0) {
        daysUntil += 7;
      }

      const targetDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + daysUntil));

      return this.zonedDateTimeToDate(
        targetDate.getUTCFullYear(),
        targetDate.getUTCMonth() + 1,
        targetDate.getUTCDate(),
        time.hour,
        time.minute,
        this.timeZone
      );
    }

    parseTime(value) {
      const match = String(value).trim().match(/^(\d{1,2}):(\d{2})$/);

      if (!match) {
        return null;
      }

      const hour = Number(match[1]);
      const minute = Number(match[2]);

      if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        return null;
      }

      return { hour, minute };
    }

    isValidDateParts(year, month, day) {
      const date = new Date(Date.UTC(year, month - 1, day));

      return date.getUTCFullYear() === year && date.getUTCMonth() + 1 === month && date.getUTCDate() === day;
    }

    getDayOfWeek(year, month, day) {
      return new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    }

    getZonedParts(date, timeZone) {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
      const values = {};

      formatter.formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') {
          values[part.type] = Number(part.value);
        }
      });

      return values;
    }

    getTimeZoneOffset(date, timeZone) {
      const parts = this.getZonedParts(date, timeZone);
      const utcDate = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);

      return utcDate - date.getTime();
    }

    zonedDateTimeToDate(year, month, day, hour, minute, timeZone) {
      const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));
      const firstOffset = this.getTimeZoneOffset(utcGuess, timeZone);
      const firstDate = new Date(utcGuess.getTime() - firstOffset);
      const secondOffset = this.getTimeZoneOffset(firstDate, timeZone);

      if (firstOffset !== secondOffset) {
        return new Date(utcGuess.getTime() - secondOffset);
      }

      return firstDate;
    }

    setValues(days, hours, minutes, seconds) {
      this.days.textContent = String(days).padStart(2, '0');
      this.hours.textContent = String(hours).padStart(2, '0');
      this.minutes.textContent = String(minutes).padStart(2, '0');
      this.seconds.textContent = String(seconds).padStart(2, '0');
    }

    showExpired() {
      if (this.expired) {
        this.expired.hidden = false;
      }
    }
  }

  const initializePasswordReassortCountdowns = (container = document) => {
    container.querySelectorAll('[data-password-reassort-timer]').forEach((element) => {
      if (element.dataset.passwordReassortInitialized === 'true') {
        return;
      }

      element.dataset.passwordReassortInitialized = 'true';
      new PasswordReassortCountdown(element);
    });
  };

  initializePasswordReassortCountdowns();

  document.addEventListener('shopify:section:load', (event) => {
    initializePasswordReassortCountdowns(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
